import { AxiosResponse } from "axios";
import AxiosInstance from "@/components/Axios";

export async function downloadDocuments(projectId: string): Promise<void> {
	try {
		// Set responseType to 'blob' to handle binary file data
		const response = await AxiosInstance.post(
			`/api/afs/download`,
			{ project_id: projectId },
			{ responseType: "blob" },
		);

		return downloadFileFromResponse(response);
	} catch (error) {
		console.error("Error downloading documents:", error);
		return Promise.reject(error);
	}
}

export async function downloadProposals(projectId: string): Promise<void> {
	try {
		const response = await AxiosInstance.post(
			`/api/afs/download-proposals`,
			{ project_id: projectId },
			{ responseType: "blob" },
		);
		return downloadFileFromResponse(response);
	} catch (error) {
		console.error("Error downloading proposals:", error);
		return Promise.reject(error);
	}
}

// This does the same thing as above but just calls the public endpoint instead of the private one.
export async function downloadDocumentsQR(projectId: string): Promise<void> {
	try {
		// Set responseType to 'blob' to handle binary file data
		const response = await AxiosInstance.get(`/api/afs/qr-download`, {
			params: { project_id: projectId },
			responseType: "blob",
		});

		// Get filename from content-disposition header if available
		const contentDisposition = response.headers["content-disposition"];
		let filename = "download";

		if (contentDisposition) {
			const filenameMatch = contentDisposition.match(
				/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
			);
			if (filenameMatch && filenameMatch[1]) {
				filename = filenameMatch[1].replace(/['"]/g, "");
			}
		}

		// If filename doesn't have extension, try to add one based on content type
		if (!filename.includes(".")) {
			const contentType = response.headers["content-type"];
			if (contentType === "application/pdf") {
				filename += ".pdf";
			} else if (contentType === "application/zip") {
				filename += ".zip";
			}
		}

		// Create a blob URL for the file
		const blob = new Blob([response.data], {
			type: response.headers["content-type"],
		});
		const url = window.URL.createObjectURL(blob);

		// Create a temporary link element to trigger download
		const link = document.createElement("a");
		link.href = url;
		link.setAttribute("download", filename);
		document.body.appendChild(link);

		// Trigger download and clean up
		link.click();
		window.URL.revokeObjectURL(url);
		document.body.removeChild(link);

		return Promise.resolve();
	} catch (error) {
		console.error("Error downloading file:", error);
		return Promise.reject(error);
	}
}

// This is a helper function to download a file from a response
export async function downloadFileFromResponse(
	response: AxiosResponse,
): Promise<void> {
	// Get filename from content-disposition header if available
	const contentDisposition = response.headers["content-disposition"];
	let filename = "download";

	if (contentDisposition) {
		const filenameMatch = contentDisposition.match(
			/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
		);
		if (filenameMatch && filenameMatch[1]) {
			filename = filenameMatch[1].replace(/['"]/g, "");
		}
	}

	// If filename doesn't have extension, try to add one based on content type
	if (!filename.includes(".")) {
		const contentType = response.headers["content-type"];
		if (contentType === "application/pdf") {
			filename += ".pdf";
		} else if (contentType === "application/zip") {
			filename += ".zip";
		}
	}

	// Create a blob URL for the file
	const blob = new Blob([response.data], {
		type: response.headers["content-type"],
	});
	const url = window.URL.createObjectURL(blob);

	// Create a temporary link element to trigger download
	const link = document.createElement("a");
	link.href = url;
	link.setAttribute("download", filename);
	document.body.appendChild(link);

	// Trigger download and clean up
	link.click();
	window.URL.revokeObjectURL(url);
	document.body.removeChild(link);

	return Promise.resolve();
}

